import FakeRevenueApi from "./FakeRevenueApi";
import RealRevenueApi from "./RealRevenueApi";
import CommonRequestBodyDto from "../dto/common/CommonRequestBodyDto";
import RevenueVoidReqDto from "../dto/revenue/RevenueVoidReqDto";
import IndiaTransactionReqDto from "../dto/revenue/IndiaTransactionReqDto";

type DateRange = { startDate: string; endDate: string };

class RevenueApi {
    fakeApi = false;
    fake = new FakeRevenueApi();
    real = new RealRevenueApi();

    getRevenueAnalysis = ({ startDate, endDate }: DateRange) => {
        if (this.fakeApi) return this.fake.getRevenueAnalysis();
        return this.real.getRevenueAnalysis({ startDate, endDate });
    };

    getRevenueShop = ({ startDate, endDate }: DateRange) => {
        if (this.fakeApi) return this.fake.getRevenueShop();
        return this.real.getRevenueShop({ startDate, endDate });
    };

    getRevenueDay = ({ startDate, endDate }: DateRange) => {
        if (this.fakeApi) return this.fake.getRevenueDay();
        return this.real.getRevenueDay({ startDate, endDate });
    };

    getRevenueTotal = ({ startDate, endDate }: DateRange) => {
        if (this.fakeApi) return this.fake.getRevenueTotal();
        return this.real.getRevenueTotal({ startDate, endDate });
    };

    getRevenueOrderList = ({
        orderId,
        shopCode,
        shopName,
        deviceName,
        startDate,
        endDate,
        result,
        page,
        pageSize,
    }: {
        orderId?: string;
        shopCode?: string;
        shopName?: string;
        deviceName?: string;
        startDate: string;
        endDate: string;
        result?: string;
        page: number;
        pageSize: number;
    }) => {
        if (this.fakeApi) return this.fake.getRevenueOrderList();
        return this.real.getRevenueOrderList({
            orderId,
            shopCode,
            shopName,
            deviceName,
            startDate,
            endDate,
            result,
            page,
            pageSize,
        });
    };

    saveRevenueVoid = (reqDto: CommonRequestBodyDto<RevenueVoidReqDto>) => {
        if (this.fakeApi) return this.fake.saveRevenueVoid();
        return this.real.saveRevenueVoid(reqDto);
    };

    getRevenueVoid = ({ startDate, endDate }: DateRange) => {
        if (this.fakeApi) return this.fake.getRevenueVoid();
        return this.real.getRevenueVoid({ startDate, endDate });
    };

    uploadIndiaTransaction = (reqDto: CommonRequestBodyDto<IndiaTransactionReqDto>) => {
        if (this.fakeApi) return this.fake.uploadIndiaTransaction();
        return this.real.uploadIndiaTransaction(reqDto);
    };

    getIndiaReport = (params: {
        transactionId?: string;
        shopCode?: string;
        shopName?: string;
        deviceName?: string;
        startday: string;
        endday: string;
        result: string;
        ordertype?: string;
    }) => {
        if (this.fakeApi) return this.fake.getIndiaReport();
        return this.real.getIndiaReport(params);
    };

    getUsageDay = ({ startDate, endDate }: DateRange) => {
        if (this.fakeApi) return this.fake.getUsageDay();
        return this.real.getUsageDay({ startDate, endDate });
    };

    getUsageWeek = ({ startDate, endDate }: DateRange) => {
        if (this.fakeApi) return this.fake.getUsageWeek();
        return this.real.getUsageWeek({ startDate, endDate });
    };

    getUsageHourWeek = ({ startDate, endDate }: DateRange) => {
        if (this.fakeApi) return this.fake.getUsageHourWeek();
        return this.real.getUsageHourWeek({ startDate, endDate });
    };

    getUsageShop = ({ startDate, endDate }: DateRange) => {
        if (this.fakeApi) return this.fake.getUsageShop();
        return this.real.getUsageShop({ startDate, endDate });
    };

    getUsageDevice = ({ startDate, endDate }: DateRange) => {
        if (this.fakeApi) return this.fake.getUsageDevice();
        return this.real.getUsageDevice({ startDate, endDate });
    };

    generateRevenueCumulative = () => {
        if (this.fakeApi) return this.fake.generateRevenueCumulative();
        return this.real.generateRevenueCumulative();
    };
}

export default RevenueApi;
